/* eslint no-unused-vars: 0  */
/* eslint no-inner-declarations: 0 */
/* global $ */

/*
Any custom project animations
*/
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

$(window).on('load', () => {
  $('.driver').each(function() {
    const semicircle = $(this).find('.semi-circle');
    const checkmark = $(this).find('.checkmark');
    const line = $(this).find('.line');

    const animateIn = gsap.timeline({
      scrollTrigger: {
        trigger: semicircle,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });

    animateIn.fromTo(
      semicircle,
      {
        strokeDasharray: 129,
        strokeDashoffset: 129,
      },
      {
        strokeDashoffset: 0,
        duration: 1,
        ease: 'power4',
      },
    );

    animateIn.fromTo(
      line,
      {
        height: 0,
      },
      {
        height: 'calc(100% - 36px)',
        delay: 0.35,
        duration: 1,
        ease: 'power4',
      },
      '<',
    );

    animateIn.fromTo(
      checkmark,
      {
        strokeDasharray: 28,
        strokeDashoffset: 28,
      },
      {
        strokeDashoffset: 0,
        duration: 1,
        delay: 0.35,
        ease: 'power4',
      },
      '<',
    );
  });

  // Home Topper Parallax
  if ($('.topper-home').length) {
    gsap.to('.topper-home .hexagon-svg', {
      yPercent: -80,
      ease: 'none',
      scrollTrigger: {
        scrub: 1,
      },
    });
    gsap.to('.topper-home .hex-small', {
      yPercent: 160,
      ease: 'none',
      scrollTrigger: {
        scrub: 1,
      },
    });
  }

  // Recent News Parallax
  if ($('.recent-news-section').length) {
    gsap.to('.recent-news-section .hexagon-dots', {
      yPercent: 5,
      ease: 'none',
      scrollTrigger: {
        trigger: '.recent-news-section .hexagon-dots',
        scrub: 1,
      },
    });
    gsap.to('.recent-news-section .hexagon', {
      yPercent: -35,
      ease: 'none',
      scrollTrigger: {
        trigger: '.recent-news-section .hexagon',
        scrub: 1,
      },
    });
    gsap.to('.recent-news-section .hex-small', {
      yPercent: 60,
      ease: 'none',
      scrollTrigger: {
        trigger: '.recent-news-section .hex-small',
        scrub: 1,
      },
    });
  }

  // Our Work Mobile Hexes Parallax
  if ($('.scroll-side').length) {
    ScrollTrigger.matchMedia({
      '(max-width: 991px)': () => {
        const sections = gsap.utils.toArray('.scroll-side .capability-section');
        sections.forEach((section) => {
          const hexDots = $(section).find('.hexagon-dots');
          const hexagon = $(section).find('.hexagon');
          const hexSmall = $(section).find('.hex-small');
          gsap.to(hexDots, {
            yPercent: 5,
            ease: 'none',
            scrollTrigger: {
              scrub: 1,
              trigger: hexDots,
            },
          });
          gsap.to(hexagon, {
            yPercent: -35,
            ease: 'none',
            scrollTrigger: {
              scrub: 1,
              trigger: hexagon,
            },
          });
          gsap.to(hexSmall, {
            yPercent: 60,
            ease: 'none',
            scrollTrigger: {
              scrub: 1,
              trigger: hexSmall,
            },
          });
        });
      },
    });
  }

  // Community Stories Parallax
  if ($('.join-rin-impact-section').length) {
    gsap.to('.join-rin-impact-section .hexagon-dots', {
      yPercent: 5,
      ease: 'none',
      scrollTrigger: {
        trigger: '.join-rin-impact-section .hexagon-dots',
        scrub: 1,
      },
    });
    gsap.to('.join-rin-impact-section .hexagon', {
      yPercent: -35,
      ease: 'none',
      scrollTrigger: {
        trigger: '.join-rin-impact-section .hexagon',
        scrub: 1,
      },
    });
    gsap.to('.join-rin-impact-section .hex-small', {
      yPercent: 60,
      ease: 'none',
      scrollTrigger: {
        trigger: '.join-rin-impact-section .hex-small',
        scrub: 1,
      },
    });
  }

  // Network dots animation
  if ($('#networkCanvas').length) {
    // Set variables
    const show = 7;
    const canvas = document.getElementById('networkCanvas');
    const scene = canvas.getContext('2d');
    scene.scale(2, 2);
    let width = canvas.clientWidth * 2;
    let height = canvas.clientHeight * 2;
    canvas.width = canvas.clientWidth * 2;
    canvas.height = canvas.clientHeight * 2;

    // Create dots
    let dots;

    // Create dot
    class Dot {
      constructor() {
        const angle = Math.floor(Math.random() * 360);

        this.size = 20;
        this.dx = Math.cos(angle) * 1;
        this.dy = Math.sin(angle) * 1;

        let posX = Math.random() * width;
        if (posX <= width / 2) {
          posX += this.size;
        } else {
          posX -= this.size;
        }

        let posY = Math.random() * height;
        if (posY <= height / 2) {
          posY += this.size;
        } else {
          posY -= this.size;
        }
        this.px = posX;
        this.py = posY;
      }

      // Update dot position and draw
      update() {
        this.bounds();

        this.px += this.dx;
        this.py += this.dy;

        this.draw();
      }

      // Draw the dots then connect them
      draw() {
        scene.beginPath();
        scene.arc(this.px, this.py, this.size, 0, Math.PI * 2);
        scene.closePath();
        scene.fillStyle = '#a3e2b5';
        scene.fill();

        this.connect();
      }

      // Connect the nearby dots
      connect() {
        const nearby = (width + height) * 0.4;

        dots.forEach((dot) => {
          const distance = this.distance(dot);

          if (distance > nearby) return;

          const opacity = 1 - distance / nearby - 0.1;

          scene.beginPath();
          scene.lineWidth = 4;
          scene.strokeStyle = `rgba(163, 226, 181, ${opacity})`;
          scene.moveTo(this.px, this.py);
          scene.lineTo(dot.px, dot.py);
          scene.stroke();
        });
      }

      // Check if we've hit a wall and invert the direction
      bounds() {
        if (this.px < this.size || this.px > width - this.size) this.dx *= -1;

        if (this.py < this.size || this.py > height - this.size) this.dy *= -1;
      }

      // Calculate the distance between this dot and that dot
      // This calculates two 'sides' then the hypotenuse i.e. distance
      distance(dot) {
        const distX = this.px - dot.px;
        const distY = this.py - dot.py;

        return Math.sqrt(distX * distX + distY * distY);
      }
    }

    // Create dots
    dots = [
      ...Array(show)
        .fill()
        .map(() => new Dot()),
    ];

    // Draw scene
    function draw() {
      scene.clearRect(0, 0, width, height);

      // Update all dots and redraw
      dots.forEach((particle) => {
        particle.update();
      });

      requestAnimationFrame(draw);
    }

    draw();

    // Resize canvas
    window.addEventListener('resize', () => {
      canvas.width = canvas.clientWidth * 2;
      canvas.height = canvas.clientHeight * 2;
      width = canvas.clientWidth * 2;
      height = canvas.clientHeight * 2;
    });
  }

  const numSections = $('.scroll-side section').length;

  if (numSections) {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: '.capability-sections',
          scrub: 0.2,
          start: 'top top',
          end: 'bottom bottom',
        },
      })
      .to('.sticky-side .hexagon-svg', {
        rotation: -60 * (numSections - 1),
        duration: 1,
        ease: 'none',
      });
    gsap
      .timeline({
        scrollTrigger: {
          trigger: '.capability-sections',
          scrub: 0.2,
          start: 'top top',
          end: 'bottom bottom',
        },
      })
      .to('.sticky-side .hexagon', {
        rotation: 60 * (numSections - 1),
        duration: 1,
        ease: 'none',
      });
  }
});
